export type ResourceType = "fiche" | "activite" | "imprimable" | "guide" | "routine" | "parents";
export type ResourceAudience = "kid" | "teen" | "adult" | "parent" | "teacher";

export interface Resource {
  id: string;
  title: string;
  type: ResourceType;
  audience: ResourceAudience;
  duration: number;
  content: string;
  themeId: string;
}

const biasResources: Resource[] = [
  {
    id: "bc_res_fiche",
    title: "Repérer le biais de confirmation",
    type: "fiche",
    audience: "adult",
    duration: 10,
    content: "Guide synthétique pour identifier le biais, avec 3 questions rapides a se poser.",
    themeId: "biais-confirmation",
  },
  {
    id: "bc_res_activite",
    title: "Activite familiale : voir l'autre point de vue",
    type: "activite",
    audience: "parent",
    duration: 15,
    content: "Un exercice en famille pour lister des arguments pour/contre une idee et en discuter calmement.",
    themeId: "biais-confirmation",
  },
  {
    id: "bc_res_guide",
    title: "Guide enseignant : debattre sans bulle",
    type: "guide",
    audience: "teacher",
    duration: 12,
    content: "Conseils pour animer un debat en classe et aider les eleves a chercher des sources opposees.",
    themeId: "biais-confirmation",
  },
  {
    id: "bc_res_parents",
    title: "Fiche parents : parler du biais au quotidien",
    type: "parents",
    audience: "parent",
    duration: 8,
    content: "Exemples quotidiens et 3 questions a poser en famille pour nuancer les jugements.",
    themeId: "biais-confirmation",
  },
];

const biasAliases: Resource[] = [
  {
    ...biasResources[3],
    id: "res-biais-parents-1",
    type: "fiche",
  },
];

export const demoResources: Resource[] = [...biasResources, ...biasAliases];

export const allResources: Resource[] = [...demoResources];
